// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxCell_checkbox__WVKgP","header":"CheckboxCell_header__Gw4g8","checkboxCellContainer":"CheckboxCell_checkboxCellContainer__R7gLo"};